import { TableColTypeRender, TableColTypeDef } from '../type'

const result:Record<string, TableColTypeRender> = {}

const files = require.context('./', true, /\.ts$/)
files.keys()
  .forEach((key) => {
    if (!files(key).default) return
    if (key === './index.ts') return
    const module:TableColTypeDef = files(key).default
    // 循环文件中的导出
    if (module.name === undefined || module.render === undefined) return
    if (typeof module.render === 'function') {
      result[module.name] = module.render
    }
  })

export default result
